import { Component, OnInit } from '@angular/core';
import { ApiService, UserInfo } from '../../services/api.service'
import { MenuService } from '../../services/menu.service'
import { AccountType } from '../../interfaces/api/AccountType'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { ButtonComponent } from '@components/button/button.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { NgForOf } from '@angular/common'
import { HeaderComponent } from '@components/header/header.component';
import { VisualizerItemComponent } from '@components/visualizer-item/visualizer-item.component';
import { buildProductUrl } from '@assets/i18n/locales';

@Component({
    standalone: true,
    selector: 'app-visualizers',
    templateUrl: './visualizers.component.html',
    imports: [
        CosentinoSvgComponent,
        ButtonComponent,
        TranslateModule,
        NgForOf,
        HeaderComponent,
        VisualizerItemComponent
    ],
    styleUrl: './visualizers.component.scss'
})
export class VisualizersComponent implements OnInit {
    userInfo: UserInfo;

     visualizerItems = [
        {
            imageUrl: 'assets/images/visualizers/kitchen-visualizer2.jpg',
            title: 'visualizers.visualizadores_lc_kitchen_visualizer',
            description: 'visualizers.visualizer_lc_kitchenvisualizerdesc',
            link: ''
        },
        {
            imageUrl: 'assets/images/visualizers/bathroom-visualizer2.jpg',
            title: 'visualizers.visualizadores_lc_bathroom_visualizer',
            description: 'visualizers.visualizer_lc_bathroomvisualizerdesc',
            link: ''
        },
        {
            imageUrl: 'assets/images/visualizers/online-visualizer.jpg',
            title: 'visualizers.visualizadores_lc_online_visualizer',
            description: 'visualizers.visualizer_lc_onlinevisualizerdesc',
            link: ''
        },
        {
            imageUrl: 'assets/images/visualizers/moodboards.png',
            title: 'visualizers.visualizadores_lc_digital_moodboards',
            description: 'visualizers.visualizer_lc_moodboardsdesc',
            link: 'https://moodboard.cosentino.com/home'
        }
    ];

    constructor(private api: ApiService, protected menuService: MenuService, private translate: TranslateService) {}

    private translations(){
        this.translate.get([
            'visualizers.visualizadores_lc_kitchen_visualizer',
            'visualizers.visualizer_lc_kitchenvisualizerdesc',
            'visualizers.visualizadores_lc_bathroom_visualizer',
            'visualizers.visualizer_lc_bathroomvisualizerdesc',
            'visualizers.visualizadores_lc_online_visualizer',
            'visualizers.visualizer_lc_onlinevisualizerdesc',
            'visualizers.visualizadores_lc_digital_moodboards',
            'visualizers.visualizer_lc_moodboardsdesc'
        ])
    }

    ngOnInit() {
        this.api.userInfo.subscribe(userInfo => {
            this.userInfo = userInfo;

            const countryUppercase = userInfo.country?.toUpperCase?.() ?? '';
            const country = this.userInfo.country?.toLowerCase() ?? 'es';
            this.visualizerItems[0].link = buildProductUrl(countryUppercase, 'kitchenVisualizer');
            this.visualizerItems[1].link = buildProductUrl(countryUppercase, 'bathroomVisualizer');
            this.visualizerItems[2].link = `https://visualizer.cosentino.com/?country=${country}`;
        });
    }

    protected readonly AccountType = AccountType
}
